/* eslint-disable linebreak-style */
import React from 'react';
const CriticalIllnessStepShared = () => (
  <ol>
    <li>
    Physician Attending statement
    </li>
    <li>
    Proof of Outstanding Dues (invoice or other documentation received from developer)
    </li>
  </ol>
);

export default CriticalIllnessStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.MedicalHardshipStep/components/CriticalIllnessStepShared.js